import classNames from "classnames";

import { SHARED_PLATFORM_ROUTES } from "@ascendnow/shared";

import styles from "./AscBanner.module.scss";
import { CheckActiveIcon } from "../AscIcons";
import AscParagraph from "../AscTypography/AscParagraph/AscParagraph";
import AscLink from "../AscLink/AscLink";

export interface AscBannerProps {
  textOrHtml: string;
  backgroundColor?: string;
  className?: string;
}

export default function AscBanner({
  textOrHtml,
  backgroundColor = "#d5efd1",
  className,
}: AscBannerProps) {
  return (
    <div
      data-testid="asc-banner"
      className={classNames(styles.ground, className)}
      style={{ backgroundColor }}
    >
      <div className={styles.left}>
        <CheckActiveIcon className={styles.checkIcon} />
        <AscParagraph>
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: textOrHtml }}
          />
        </AscParagraph>
      </div>
      <AscLink
        className={styles.link}
        showIcon
        href={SHARED_PLATFORM_ROUTES.challenges_ranks_global + "?period=month"}
        innerWrapperTag="button"
      >
        See details
      </AscLink>
    </div>
  );
}
